import React from 'react'

import { Box, Card, CardContent, CardHeader, Grid } from '@mui/material'

import { renderProgress } from 'utils/render/campaign-details'

type CampaignHealthStatsProps = {
  data: any
}

const config = [
  {
    title: 'Last week completion average',
    render: renderProgress('lastWeekCompletion')('lastWeekMatchedViewsPerDay', 'totalViewsPerDay'),
  },
  {
    title: 'Projected views',
    render: renderProgress('projectedViews')('projectedTotalViews', 'totalViews'),
  },
  {
    title: 'Views to deliver (daily)',
    field: 'dailyViewsToDeliver',
  },
]

const CampaignHealthStats = ({ data }: CampaignHealthStatsProps) => (
  <Box sx={{ mb: '1rem' }}>
    <Grid container spacing={2}>
      {config.map((card: any, index: number) => (
        <Grid
          key={index}
          size={{
            sm: 4,
          }}>
          <Card style={{ height: '100%' }}>
            <CardHeader subheader={card.title} />
            <CardContent>{card.render ? card.render(data) : data[card.field] || ''}</CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Box>
)

export default CampaignHealthStats
